type Props = {
  message?: string
}

const EmptyResult: React.FC<Props> = ({message = "No records found"}) => {
  return (
    <>
      <div className="mb-3 p-4 bg-white text-center rounded card-border">{message}</div>
    </>
  )
}

export default EmptyResult